import script from "./MessageWithReactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageWithReactions.vue?vue&type=script&setup=true&lang=ts"

import "./MessageWithReactions.vue?vue&type=style&index=0&id=6b98e496&lang=scss"

const __exports__ = script;

export default __exports__